import { BaseParams, ISetParamsAdapter } from './base-params';

export interface PageParamsLike {
  skip?: number;
  take?: number;

  skipOptional?: number;
  takeOptional?: number;
}

export class PageParams<
    T extends PageParams = PageParams<any, any>,
    I extends PageParamsLike = PageParamsLike
  >
  extends BaseParams<T, I>
  implements PageParamsLike
{
  skip?: number;
  take?: number;

  skipOptional?: number;
  takeOptional?: number;

  setSkip(skip: number) {
    this.skip = skip;
    return this;
  }

  setTake(take: number) {
    this.take = take;
    return this;
  }

  setSkipOptional(skipOptional: number) {
    this.skipOptional = skipOptional;
    return this;
  }

  setTakeOptional(takeOptional: number) {
    this.takeOptional = takeOptional;
    return this;
  }

  getSkip() {
    return this.skip ?? this.skipOptional;
  }

  getTake() {
    return this.take ?? this.takeOptional;
  }

  apply(options?: Partial<PageParamsLike>): void {
    this.skip = options?.skip;
    this.take = options?.take;

    this.skipOptional = options?.skipOptional;
    this.takeOptional = options?.takeOptional;
  }

  protected _handleParamsAdapter(paramsAdapter: ISetParamsAdapter): void {
    const skip = this.getSkip();
    const take = this.getTake();
    if (typeof skip === 'number') {
      paramsAdapter.set('resultOffset', String(skip));
    }
    if (typeof take === 'number') {
      paramsAdapter.set('resultRecordCount', String(take));
    }
  }
}
